import { Component } from 'react';
import { changeBackground, createDiv, changeNumber, toggleTemperature } from './helper';
import './styles/animations.css';
import './styles/Background.css';
import './styles/Permission.css';
import './styles/Error.css';
import './styles/Loading.css';
import './styles/App.css';

function Image(props) {
  return (
    <picture>
      <source srcSet={require(`.//assets/${props.folder}/${props.fileName}.avif`)} type="image/avif" />
      <source srcSet={require(`.//assets/${props.folder}/${props.fileName}.webp`)} type="image/webp" />
      <img src={require(`.//assets/${props.folder}/${props.fileName}.png`)} alt="" width={props.width} height={props.height} />
    </picture>
  );
}

function Background(props) {
  return (
    <div className="Background" aria-hidden="true">
      <Image folder="backgrounds" fileName="background" width="1920" height="1080" />
      <div>
        {props.accepted && <a href="https://www.flaticon.com/free-icons/sun" title="sun icons" target="_blank" rel="noreferrer">Sun icons created by Circlon Tech - Flaticon</a>}
        <a href="https://www.freepik.com/vectors/background" title="vector backgrounds" target="_blank" rel="noreferrer">Background vector created by freepik - www.freepik.com</a>
      </div>
    </div>
  );
}

function Permission(props) {
  return (
    <div className="Permission">
      <h2>Enable Location</h2>
      <p>Please allow us to access your location. By allowing access, you can view weather data in your current area.</p>
      <div>
        <button type="button" onClick={props.accept}>ALLOW</button>
        <button type="button" onClick={props.deny}>SKIP</button>
      </div>
    </div>
  );
}

function Error(props) {
  return (
    <div className="Error">
      <h2>SORRY...</h2>
      <p>We couldn't find your location.</p>
      <button type="button" onClick={props.goBack}>GO BACK</button>
    </div>
  );
}

const Loading = () => <div className="Loading">{createDiv(10)}</div>;

class Location extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scale: '',
      date: new Date()
    };
    this.toFahrenheit = this.toFahrenheit.bind(this);
    this.toCelcius = this.toCelcius.bind(this);
  }

  componentDidMount() {
    this.interval = setInterval(() => this.setState({ date: new Date() }), 1000);
    this.toCelcius();
  }

  componentWillUnmount() { clearInterval(this.interval); }

  toFahrenheit() {
    document.querySelector('.Location BUTTON:first-of-type').style.opacity = '0.5';
    document.querySelector('.Location BUTTON:last-of-type').style.opacity = '1';
    this.setState({ scale: 'F' });
  }

  toCelcius() {    
    document.querySelector('.Location BUTTON:first-of-type').style.opacity = '1';
    document.querySelector('.Location BUTTON:last-of-type').style.opacity = '0.5';
    this.setState({ scale: 'C' });
  }

  render() {
    const { scale, date } = this.state,
    data = this.props.data,
    months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'November', 'December'];
    return (
      <div className="Location">
        <p>{months[date.getMonth()]} {date.getDate()}, {changeNumber(date.getHours())}:{changeNumber(date.getMinutes())}</p>
        <p>Min {toggleTemperature(scale, data.main.temp_min)}<sup>o</sup> <span /> Max {toggleTemperature(scale, data.main.temp_max)}<sup>o</sup></p>
        <div>
          <p>{toggleTemperature(scale, data.main.temp)}<sup>o</sup></p>
          <div>
            <button type="button" onClick={this.toCelcius}>C</button>
            <button type="button" onClick={this.toFahrenheit}>F</button>
          </div>
        </div>
        <p>Feels like {toggleTemperature(scale, data.main.feels_like)}<sup>o</sup></p>
      </div>
    );
  }
}

function Icon(props) {
  const data = props.data,
  icon = data.weather[0].icon.match(/\d+/);
  return (
    <div className="Icon">
      <h1>{data.name}, {data.sys.country}</h1>
      <p>{data.weather[0].main}</p>
      <Image folder="icons" fileName={icon} width="512" height="512" />
    </div>
  );
}

function Info(props) {
  const data = props.data;
  return (
    <div className="Info">
      <p>Current details</p>
      <ul>
        <li>Humidity<span>{data.main.humidity}%</span></li>
        <li>Pressure<span>{String(data.main.pressure).replace(/\B(?=(\d{3})+(?!\d))/g, ",")} mBar</span></li>
        <li>Visibility<span>{data.visibility / 1000} km</span></li>
        <li>Wind<span>{data.wind.speed} km/h</span></li>
      </ul>
    </div>
  );
}

function Main(props) {
  return (
    <div className="Main">
      <Icon data={props.data} />
      <Location data={props.data} />
      <Info data={props.data} />
    </div>
  );
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAccepted: false,
      isLoaded: false,
      isError: false,
      data: []
    };
    this.denyAccess = this.denyAccess.bind(this);
    this.acceptAccess = this.acceptAccess.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentDidMount() { changeBackground('permission'); }

  componentWillUnmount() { navigator.geolocation.clearWatch(this.coords) }

  fetchWeather(api) {
    fetch(api)
      .then(response => response.json())
      .then(result => {
        this.setState({
          isLoaded: true,
          data: result
        });
        changeBackground(this.state.data.weather[0].icon.match(/\d+/));
      }, () => this.denyAccess());
  }

  denyAccess() {
    changeBackground('error');
    this.setState({
      isLoaded: true,
      isError: true
    });
  }

  acceptAccess() {
    this.setState({ isAccepted: true });
    this.coords = navigator.geolocation.watchPosition(position => {
      const latitude = position.coords.latitude,
      longitude = position.coords.longitude;
      this.fetchWeather(`https://weather-proxy.freecodecamp.rocks/api/current?lat=${latitude}&lon=${longitude}`);
    }, () => this.denyAccess());
  }

  goBack() {
    changeBackground('permission');
    this.setState({
      isAccepted: false,
      isLoaded: false,
      isError: false
    });
  }

  render() {
    const { isAccepted, isLoaded, isError, data } = this.state;
    return (
      <main>
        <Background accepted={isAccepted} />
        {
          isError
            ? <Error goBack={this.goBack} />
            : !isAccepted
              ? <Permission deny={this.denyAccess} accept={this.acceptAccess} />
              : !isLoaded
                ? <Loading />
                : <Main data={data} />
        }
      </main>
    );
  }
}

export default App;